/**
 * Route for `igaming-win-loss-events`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingWinLossEventsPage } from "../features/igaming-win-loss-events/IgamingWinLossEventsPage";

export const igamingWinLossEventsRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-win-loss-events",
	component: IgamingWinLossEventsPage,
});

export default igamingWinLossEventsRoute;
